import React, { useRef, useState, useEffect } from "react";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Pagination } from "semantic-ui-react";
import { SERVER_URL } from "../config";
import {
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareButton,
} from "react-share";
import SocietyJournalImg from "../assets/assets_html/images/society homepage.png";
import pg01 from "../assets/assets_html/images/perv_arrow.png";
import pg02 from "../assets/assets_html/images/next_arrow.png";
import NewsLetter from "../components/global/NewsLetter";
import coin from "../assets/img/icons/coinT.svg";
import JournalMainBanner from "../components/journals/JournalMainBanner";
import AakashgangaHeader from "../components/global/HeaderComponent";
import AakashgangaFooter from "../components/global/FooterComponent";
import Modal from "react-bootstrap/Modal";
import YoutubeIcon from "../assets/assets_html/images/Youtube-Icon.svg";
import notyet from "../assets/img/icons/notarticle.svg";
import {
  getJournalDetailById,
  getPEForJournalHomePage,
} from "../store/apiCalls/dashboard";
import { getJournalSubjects } from "../store/apiCalls/articles";
import SubmitArticleModal from "../components/Modal/SubmitArticleModal";
import { toast } from "react-toastify";
import { Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet";

const MegaEditorialBoard = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const journalName = location?.state?.journalName;
  const journalId = location?.state?.journalId;
  // console.log(journalId);
  const token = localStorage.getItem("usertoken");
  const { id, discipline } = params;
  const navigate = useNavigate();
  const limit = 5000;
  const [page, setPage] = useState(1);
  const [activeType, setActiveType] = useState("editorial-board");
  // const societyJournal = location?.state?.societyJournal;
  const societyJournal = "Mega Journal";
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [showRec, setShowRec] = useState(false);
  const [showAdvertising, setShowAdvertising] = useState(false);

  const pageName = location?.state?.pageName;
  // const journalName = location?.state?.journalName;
  const SHARE_URL = `${SERVER_URL}/mega-journals/${id}`;
  const [modalPageName, setModalPageName] = useState(pageName);
  const [modalJournalName, setJournalModalName] = useState(journalName);

  const [publishEditorData, setPublishEditorData] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [uploadArticle, setUploadArticle] = useState(false);
  let totalPages = Math.ceil(publishEditorData?.totalCount / limit);
  const [boardOrder, setboardOrder] = useState([
    {
      1: "",
      2: "",
      3: "",
      4: "",
    },
  ]);
  const title = `I recommend that you checkout ${modalJournalName}. The process of submission is fully automated and it offers affordable APCs, and a very short turnaround time.`;
  const handleCodeCopy = (e) => {
    copy(SHARE_URL);
    e.target.textContent = "Copied";
    e.target.style.setProperty("color", "#ffffff");
  };
  const addNewOrder = () => {
    setboardOrder((prevState) => {
      const newOrder = { ...prevState[0] }; // Create a copy of the first object in the array
      const nextKey = Object.keys(newOrder).length + 1; // Calculate the next key number
      newOrder[nextKey] = ""; // Add the new key with an empty string value
      return [newOrder]; // Return the updated array with the new object
    });
  };
  const isMounted = useRef(false);

  const updateBoardOrder = (key, value) => {
    // console.log("here --- ",key+" "+ value);
    setboardOrder((prevBoardOrder) =>
      prevBoardOrder.map((item) => ({
        ...item,
        [key]: value,
      }))
    );
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Add the "th" suffix to the day
    let daySuffix = "th";
    if (day === 1 || day === 21 || day === 31) {
      daySuffix = "st";
    } else if (day === 2 || day === 22) {
      daySuffix = "nd";
    } else if (day === 3 || day === 23) {
      daySuffix = "rd";
    }

    return ` ${month} ${day},  ${year}`;
  }
  const renderPosition = (data) => {
    const resultArray = data.split("-");
    // console.log("resultArray",resultArray[1])
    if (data == "associateEditors") {
      return (
        <>
          <Accordion className="editorial-board-ds pe-5" defaultActiveKey="6">
            {journalData?.advisoryBoard?.length > 0
              ? journalData?.advisoryBoard && (
                  <>
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        Associate Editor
                        {journalData?.advisoryBoard?.length > 1 ? (
                          <span style={{ textTransform: "lowercase" }}>/s</span>
                        ) : null}
                      </Accordion.Header>
                      <Accordion.Body>
                        {journalData?.advisoryBoard?.map((item, ind) => {
                          const matchedEmail = "director.cdp@mriu.edu.in";
                          const matchedWebsite =
                            "https://www.manavrachna.edu.in/mriirs/academics/teaching-faculty/nandini-srivastava";
                          return (
                            <div key={ind} style={{ marginBottom: "12px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <p className="mb-0 fw-bold">
                                  {item?.hyperlink ? (
                                    <a
                                      href={item?.hyperlink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        textDecoration: "none",
                                        color: "#336d91",
                                      }}
                                    >
                                      {item?.title} {item?.fullName}
                                    </a>
                                  ) : (
                                    <>
                                      {item?.title} {item?.fullName}
                                    </>
                                  )}
                                </p>
                                {item?.email && (
                                  <span
                                    style={{
                                      textTransform: "lowercase",
                                      fontStyle: "italic",
                                      fontSize: "14px",
                                    }}
                                  >
                                    ( {item?.email} )
                                  </span>
                                )}
                              </div>
                              <p className="mb-0  designation">
                                {item?.designation}
                              </p>
                              <p className="mb-0">{item?.workPlace}</p>
                              {item?.address && (
                                <p className="mb-2">{item?.address}</p>
                              )}
                            </div>
                          );
                        })}
                      </Accordion.Body>
                    </Accordion.Item>
                  </>
                )
              : null}
          </Accordion>
        </>
      );
    } else if (data == "assistantEditor") {
      return (
        <>
          <Accordion className="editorial-board-ds pe-5" defaultActiveKey="0">
            {journalData?.editor == null ? null : (
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Assistant Editor{" "}
                  {journalData?.editor?.length > 1 ? (
                    <span style={{ textTransform: "lowercase" }}>/s</span>
                  ) : null}
                </Accordion.Header>
                <Accordion.Body>
                  {journalData?.editor?.map((item, ind) => (
                    <>
                      <p className="mb-0 fw-bold">
                        {item?.hyperlink ? (
                          <a
                            href={item?.hyperlink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "#336d91",
                            }}
                          >
                            {item?.title} {item?.fullName}
                          </a>
                        ) : (
                          <>
                            {item?.title} {item?.fullName}
                          </>
                        )}
                      </p>
                      <p className="mb-0  designation">{item?.designation}</p>
                      <p className="mb-0">{item?.nameOfUniversity}</p>
                      {item?.address && <p className="mb-2">{item?.address}</p>}
                    </>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </>
      );
    } else if (data == "managingEditor") {
      return (
        <>
          <Accordion className="editorial-board-ds pe-5" defaultActiveKey="3">
            {journalData?.managingEditor == null ? null : (
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  Managing Editor
                  {journalData?.managingEditor?.length > 1 ? (
                    <span style={{ textTransform: "lowercase" }}>/s</span>
                  ) : null}
                </Accordion.Header>
                <Accordion.Body>
                  {journalData?.managingEditor?.map((item, ind) => (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <p className="mb-0 fw-bold">
                          {item?.hyperlink ? (
                            <a
                              href={item?.hyperlink}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "#336d91",
                              }}
                            >
                              {item?.title} {item?.fullName}
                            </a>
                          ) : (
                            <>
                              {item?.title} {item?.fullName}
                            </>
                          )}
                        </p>
                        {item?.email && (
                          <span
                            style={{
                              textTransform: "lowercase",
                              fontStyle: "italic",
                              fontSize: "14px",
                            }}
                          >
                            ( {item?.email} )
                          </span>
                        )}
                      </div>
                      <p className="mb-0  designation">{item?.designation}</p>
                      <p className="mb-0">{item?.nameOfUniversity}</p>
                      {item?.address && <p className="mb-2">{item?.address}</p>}
                    </>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </>
      );
    } else if (data == "members") {
      return <></>;
    } else if (resultArray.length == 2) {
      return (
        <>
          {journalData?.editorialAssistant?.length > 0
            ? journalData?.members && (
                <>
                  <Accordion
                    className="editorial-board-ds pe-5"
                    defaultActiveKey="0"
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        {
                          journalData?.editorialAssistant?.[resultArray[1]]
                            ?.fieldName
                        }
                      </Accordion.Header>
                      <Accordion.Body>
                        <>
                          {/* <p className="mb-0 fw-bold">
                            {
                              journalData?.editorialAssistant?.[resultArray[1]]
                                ?.title
                            }{" "}
                            {
                              journalData?.editorialAssistant?.[resultArray[1]]
                                ?.fullName
                            }
                          </p> */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <p className="mb-0 fw-bold">
                              {journalData?.editorialAssistant?.[resultArray[1]]
                                ?.hyperlink ? (
                                <a
                                  href={
                                    journalData?.editorialAssistant?.[
                                      resultArray[1]
                                    ]?.hyperlink
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "#336d91",
                                  }}
                                >
                                  {
                                    journalData?.editorialAssistant?.[
                                      resultArray[1]
                                    ]?.title
                                  }{" "}
                                  {
                                    journalData?.editorialAssistant?.[
                                      resultArray[1]
                                    ]?.fullName
                                  }
                                </a>
                              ) : (
                                <>
                                  {
                                    journalData?.editorialAssistant?.[
                                      resultArray[1]
                                    ]?.title
                                  }{" "}
                                  {
                                    journalData?.editorialAssistant?.[
                                      resultArray[1]
                                    ]?.fullName
                                  }
                                </>
                              )}
                            </p>
                            {journalData?.editorialAssistant?.[resultArray[1]]
                              ?.email && (
                              <span
                                style={{
                                  textTransform: "lowercase",
                                  fontStyle: "italic",
                                  fontSize: "14px",
                                }}
                              >
                                ({" "}
                                {
                                  journalData?.editorialAssistant?.[
                                    resultArray[1]
                                  ]?.email
                                }{" "}
                                )
                              </span>
                            )}
                          </div>
                          <p className="mb-0  designation">
                            {
                              journalData?.editorialAssistant?.[resultArray[1]]
                                ?.designation
                            }
                          </p>
                          <p className="mb-0 ">
                            {
                              journalData?.editorialAssistant?.[resultArray[1]]
                                ?.nameOfUniversity
                            }
                          </p>
                          {journalData?.editorialAssistant?.[resultArray[1]]
                            ?.address && (
                            <p className="mb-2 ">
                              {
                                journalData?.editorialAssistant?.[
                                  resultArray[1]
                                ]?.address
                              }
                            </p>
                          )}
                        </>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </>
              )
            : null}
        </>
      );
    }
  };

  const handleScrollTop = () => {
    window.scroll({ top: 0, behavior: "smooth" });
  };
  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };
  const [journalData, setJournalData] = useState([]);
  const [filteredData, setFilteredData] = useState(specializationOptions);

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filtered = specializationOptions.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
    const specSearch = [...filtered];
    setFilteredData(specSearch);
  };

  const toggleSearchDropdown = () => {
    setShowSearchDropdown(!showSearchDropdown);
  };

  const getJournalDetail = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      journal:
        id === "social-sciences"
          ? "Samaj Shastra – The Mega Journal of Social Sciences"
          : id === "business-management"
          ? "Chanakya Shastra – The Mega Journal of Business and Management"
          : id === "medicine"
          ? "Charakh Shastra – The Mega Journal of Medicine"
          : id === "engineering"
          ? "Abhiyantran Shastra – The Mega Journal of Engineering"
          : id === "information-technology"
          ? "Soochna Shastra – The Mega Journal of Information Technology"
          : id === "sciences"
          ? "Vigyan Shastra – The Mega Journal of Sciences"
          : id === "ayurveda-and-yoga"
          ? "AyurYoga Shastra – The Mega Journal of Ayurveda and Yoga"
          : id === "society-institute-university"
          ? "Society Journals – The Society Journal of Sciences"
          : null,
    };
    const response = await getJournalDetailById(headers, params);
    if (response?.status === 200) {
      if (!isMounted.current) {
        isMounted.current = true;
        response?.data?.data?.editorialAssistant?.forEach(() => {
          addNewOrder();
        });
      }

      setJournalData(response?.data?.data);
      getAllSubject(response?.data?.data?.journalName);
      if (response?.data?.data?.managingEditor?.[0]?.order) {
        updateBoardOrder(
          response?.data?.data?.managingEditor?.[0]?.order,
          "managingEditor"
        );
      }
      if (response?.data?.data?.advisoryBoard?.[0]?.order) {
        updateBoardOrder(
          response?.data?.data?.advisoryBoard?.[0]?.order,
          "associateEditors"
        );
      }
      if (response?.data?.data?.editor?.[0]?.order) {
        updateBoardOrder(
          response?.data?.data?.editor?.[0]?.order,
          "assistantEditor"
        );
      }
      if (response?.data?.data?.members?.[0]?.order) {
        updateBoardOrder(response?.data?.data?.members?.[0]?.order, "members");
      }
      if (response?.data?.data?.editorialAssistant?.[0]?.order) {
        response?.data?.data?.editorialAssistant.forEach((value, index) => {
          // Use `value` and `index` here
          updateBoardOrder(value?.order, `editorialAssistant-${index}`);
        });
        // updateBoardOrder(response?.data?.data?.editorialAssistant?.[0]?.order, "editorialAssistant");
      }
      // updateBoardOrder(1, "assistantEditor");
      // if(boardOrder?.[0]?.[1] == '')
      //   {
      //     getJournalDetail();
      //   }
    } else return;
  };

  const getAllSubject = async (decId) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { journalName: decId },
      headers: headers,
    };
    const response = await getJournalSubjects(queryParams);
    if (response?.status === 200) {
      let newRecord = response?.data?.data?.specilisation;
      if (decId !== "AyurYoga – The Mega Journal of Ayurveda and Yoga") {
        let specOpt = newRecord
          ?.filter(
            (spec) =>
              spec?.specialization !==
              "Other Subject (choose this option to register your subject)"
          )
          .map((spec) => spec?.specialization);
        setSpecializationOptions(specOpt);
        setFilteredData(specOpt);
      } else {
        let specOpt0 = newRecord?.[0]
          ?.filter(
            (spec) =>
              spec?.specialization !==
              "Other Subject (choose this option to register your subject)"
          )
          .map((spec) => spec?.specialization);

        let specOpt1 = newRecord?.[1]
          ?.filter(
            (spec) =>
              spec?.specialization !==
              "Other Subject (choose this option to register your subject)"
          )
          .map((spec) => spec?.specialization);
        const children = specOpt0.concat(specOpt1);
        setSpecializationOptions(children);
        setFilteredData(children);
      }
    } else {
      return toast.error("Please try again!!");
    }
  };

  const getPublishingEditorForJournal = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      journal:
        id === "social-sciences"
          ? "Samaj Shastra – The Mega Journal of Social Sciences"
          : id === "business-management"
          ? "Chanakya Shastra – The Mega Journal of Business and Management"
          : id === "medicine"
          ? "Charakh Shastra – The Mega Journal of Medicine"
          : id === "engineering"
          ? "Abhiyantran Shastra – The Mega Journal of Engineering"
          : id === "information-technology"
          ? "Soochna Shastra – The Mega Journal of Information Technology"
          : id === "sciences"
          ? "Vigyan Shastra – The Mega Journal of Sciences"
          : id === "ayurveda-and-yoga"
          ? "AyurYoga Shastra – The Mega Journal of Ayurveda and Yoga"
          : id === "society-institute-university"
          ? "Society Journals – The Society Journal of Sciences"
          : null,
      page: 1,
      limit,
    };
    const response = await getPEForJournalHomePage(headers, params);
    dispatch({ type: "SET_LOADER", payload: false });
    if (response?.status === 200) {
      setPublishEditorData(response?.data?.data);
    } else {
      dispatch({ type: "SET_LOADER", payload: true });
      return toast.error("Please try again");
    }
    //  console.log(publishEditorData);
  };

  const handlePageChange = (data) => {
    return setPage(data?.activePage);
  };

  const userDetails = (user) => {
    const info = {
      __html:
        user?.title +
        " " +
        `<b>${user?.fullName}</b>` +
        ", " +
        user?.affiliation?.affiliations?.[0]?.name,
    };
    return info;
  };

  useEffect(() => {
    if (journalId) {
      getJournalDetail();
    }
    return;
  }, [journalId]);

  useEffect(() => {
    // console.log("journalData",journalData);

    if (id) {
      getPublishingEditorForJournal();
    }
    return;
  }, [id, page]);
  // useEffect(() => {
  //   console.log("rrrrr", journalData);

  // },[EditorialBoard]);

  // console.log("publishEditorData",publishEditorData);

  useEffect(() => {
    // Call getJournalDetail on component mount
    getJournalDetail();
  }, []);
  // useEffect(() => {
  //   // Call getJournalDetail on component mount
  //   getJournalDataSociety();
  // }, [id]);

  useEffect(() => {
    // Log or handle boardOrder updates here
    // console.log(boardOrder);
    // You can add any additional logic that depends on boardOrder here
  }, [boardOrder]);

  return (
    <>
      <Helmet>
        <title>
          {id === "social-sciences"
            ? "Editorial Board | Social Sciences Journals | Aakashganga Open"
            : id === "business-management"
            ? "Editorial Board | Business and Management Journals | Aakashganga Open"
            : id === "medicine"
            ? "Editorial Board | Medicine Journals | Aakashganga Open"
            : id === "engineering"
            ? "Editorial Board | Engineering Journals | Aakashganga Open"
            : id === "information-technology"
            ? "Editorial Board | Information Technology Journals | Aakashganga Open"
            : id === "sciences"
            ? "Editorial Board | Sciences Journals | Aakashganga Open"
            : id === "ayurveda-and-yoga"
            ? "Editorial Board | Ayurveda and Yoga Journals | Aakashganga Open"
            : id === "society-institute-university"
            ? "Editorial Board | Sciences Journals | Aakashganga Open"
            : null}
        </title>
      </Helmet>
      <div className="tagbody">
        <AakashgangaHeader />
        <Link to={`/mega-journals/${id}`}>
          {" "}
          <JournalMainBanner
            imgUrl={
              societyJournal === "Society Journal"
                ? journalData?.masthead
                : journalData?.masthead
            }
          />
        </Link>
        <div className="menu-center-part ">
          <div className="journalShadow">
            <div className="ag_menu justify">
              <ul className="ag_menu ag_menuSub justify tagul">
                {societyJournal === "Society Journal" ? null : (
                  <li className="tagli">
                    <a
                      href="#"
                      class="custom-journal taga"
                      onClick={toggleSearchDropdown}
                    >
                      Disciplines{" "}
                      <img
                        src="/assets/images/downarrow.png"
                        alt="Down Arrow"
                      />
                    </a>

                    {showSearchDropdown && (
                      <div className="tagliSubNave">
                        <div className="disciplinesbg">
                          <div class="form-group has-search">
                            <span class="fa fa-search form-control-feedback"></span>
                            <input
                              type="text"
                              class="form-control input30"
                              placeholder="Type to search"
                              value={searchQuery}
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </div>
                          <ul className="disciplinesscroll">
                            {filteredData.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>
                )}

                <li className="active tagli custom-journal">
                  <Link
                    to="/open-access"
                    onClick={(e) => handleRedirect(e, "/open-access")}
                    className="custom-journal taga"
                  >
                    OPEN SCIENCE
                  </Link>
                </li>

                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    E-ISSN{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.issnNumber
                        : journalData?.issnNumber}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    ABBREVATION{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.abbreviation
                        : journalData?.abbreviation}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    {journalData?.doiurl == "" ||
                    journalData?.doiurl == undefined ||
                    journalData?.doiurl == null ? null : (
                      <>
                        <span className="colr ">
                          <a
                            className="text-lowercase"
                            href={`https://doi.org/${journalData?.doiurl}`}
                          >
                            https://doi.org/{journalData?.doiurl}
                          </a>
                        </span>
                      </>
                    )}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="journalShadow d-none">
            <div className="ag_menu justify">
              <ul className="ag_menu ag_menuSub justify tagul">
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    {/* DISCIPLINE{" "} */}
                    <span className=" text-black text-uppercase" style={{}}>
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.subjectData?.[0]?.subject?.subjectName
                        : journalData?.subjectData?.[0]?.subject?.subjectName}
                    </span>
                  </a>
                </li>
                <li className="active tagli custom-journal">
                  <Link
                    to="/open-access"
                    onClick={(e) => handleRedirect(e, "/open-access")}
                    className="custom-journal taga"
                  >
                    OPEN SCIENCE
                  </Link>
                </li>
                <li>
                  <a
                    href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
                    target="_blank"
                    class="custom-journal taga"
                  >
                    <img
                      style={{
                        width: "100px",
                        maxWidth: "100%",
                        transform: "none",
                      }}
                      src={coin}
                      alt="#"
                    />
                  </a>
                </li>
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    E-ISSN{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.issnNumber
                        : journalData?.issnNumber}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    ABBR{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.abbreviation
                        : journalData?.abbreviation}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    FIRST PUBLISHED{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: formatDate(journalData?.createdAt),
                        }}
                      ></div>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="editorContainer">
            <div className="editorPage">
              <span className="editorHead">Editorial Board</span>
              <div className="journalBackWrap ">
                <Link to={`/mega-journals/${id}`}>
                  <span>Journal Homepage</span>
                </Link>
                {!token ? (
                  <Link
                    to="/login"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRedirect(e, "/login");
                    }}
                    className="ag_btn_red ag_btn_redclr"
                  >
                    Submit Article
                  </Link>
                ) : (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setUploadArticle(true);
                    }}
                    className="ag_btn_red ag_btn_redclr"
                  >
                    Submit Article
                  </Link>
                )}
              </div>
            </div>

            <div className="bg journals-main-div d-flex">
              <div className="div70">
                <Accordion
                  className="editorial-board-ds pe-5"
                  defaultActiveKey="0"
                >
                  {journalData?.editorInChief == null ||
                  journalData?.editorInChief[0]?.fullName == "" ||
                  journalData?.editorInChief[0]?.fullName == undefined ? (
                    <></>
                  ) : (
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Editor-in-Chief</Accordion.Header>
                      <Accordion.Body>
                        {journalData?.editorInChief?.map((item, ind) => {
                          const matchedEmail = "jag@jagsheth.com";
                          const matchedWebsite = "https://www.jagsheth.com/";

                          return (
                            <div key={ind} style={{ marginBottom: "12px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <p className="mb-0 fw-bold">
                                  {item?.hyperlink ? (
                                    <a
                                      href={item?.hyperlink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        textDecoration: "none",
                                        color: "#336d91",
                                      }}
                                    >
                                      {item?.editortitle} {item?.fullName}
                                    </a>
                                  ) : (
                                    <>
                                      {item?.editortitle} {item?.fullName}
                                    </>
                                  )}
                                </p>
                                {item?.email && (
                                  <span
                                    style={{
                                      textTransform: "lowercase",
                                      fontStyle: "italic",
                                      fontSize: "14px",
                                    }}
                                  >
                                    ( {item?.email} )
                                  </span>
                                )}
                              </div>
                              <p className="mb-0 designation">
                                {item?.designation}
                              </p>
                              <p className="mb-0">{item?.nameOfUniversity}</p>
                              {item?.address && (
                                <p className="mb-2">{item?.address}</p>
                              )}
                            </div>
                          );
                        })}
                      </Accordion.Body>
                    </Accordion.Item>
                  )}
                </Accordion>

                {boardOrder.map((board, index) => (
                  <div key={index}>
                    {Object.keys(board).map((key) => (
                      <div key={key}>
                        {/* <span>Order {key}:</span>  */}
                        {renderPosition(board[key])}
                        {/* {board[key]} */}
                      </div>
                    ))}
                  </div>
                ))}

                {/* <Accordion
                  className="editorial-board-ds pe-5"
                  defaultActiveKey="0"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Publishing Editors</Accordion.Header>
                    <Accordion.Body>
                      {(() => {
                        // Mapping: priority email -> website URL
                        const priorityLinks = {
                          "nidhi@aud.ac.in":
                            "https://aud.delhi.gov.in/nidhi-kaicker",
                          "celinap@srmist.edu.in":
                            "https://www.srmist.edu.in/faculty/dr-a-celina/",
                          "anumeha.mathur@krmangalam.edu.in":
                            "https://www.krmangalam.edu.in/faculty/dr-anumeha-mathur/?utm_source=direct&utm_campaign=-faculty/dr-anumeha-mathur/",
                          "anupadhyay@iifmbhopal.edu.in":
                            "https://iifm-dev.q4hosting.com/our-faculty.php",
                        };

                        // Priority order from mapping keys
                        const priorityOrder = Object.keys(priorityLinks);

                        const editors = publishEditorData?.data || [];

                        // Step 1: Get priority editors in given sequence
                        const priorityEditors = priorityOrder
                          .map((email) =>
                            editors.find(
                              (item) =>
                                item?.user?.[0]?.email?.toLowerCase() ===
                                email.toLowerCase()
                            )
                          )
                          .filter(Boolean);

                        // Step 2: Get remaining editors
                        const otherEditors = editors.filter(
                          (item) =>
                            !priorityOrder.includes(
                              item?.user?.[0]?.email?.toLowerCase()
                            )
                        );

                        // Step 3: Final ordered list
                        const sortedEditors = [
                          ...priorityEditors,
                          ...otherEditors,
                        ];

                        // Step 4: Render editors
                        return sortedEditors.map((item, ind) => {
                          if (
                            item?.userId === "6595248d793b59aced4bf8e4" ||
                            item?.userId === "657024e815abddd272a6ae49" ||
                            item?.userId === "65828c3e8a013170ca9a4837"
                          ) {
                            return null; // skip excluded users
                          }

                          const email = item?.user?.[0]?.email?.toLowerCase();
                          const fullName =
                            item?.user?.[0]?.fullName?.toLowerCase();
                          const affiliation =
                            item?.user?.[0]?.affiliation?.affiliations?.[0];
                          const website = priorityLinks[email]; // check if this editor has a link

                          return (
                            <React.Fragment key={ind}>
                              <p className="mb-0 text-capitalize">
                                <span className="fw-bold">
                                  {website ? (
                                    <a
                                      href={website}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        textDecoration: "none",
                                        color: "#336d91",
                                      }}
                                    >
                                      {id === "medicine" ? "Dr. " : null}
                                      {fullName}
                                    </a>
                                  ) : (
                                    <>
                                      {id === "medicine" ? "Dr. " : null}
                                      {fullName}
                                    </>
                                  )}
                                </span>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontStyle: "italic",
                                    textTransform: "lowercase",
                                    fontSize: "14px",
                                  }}
                                >
                                  ( {email} )
                                </span>
                                ,{" "}
                                <span style={{ textTransform: "none" }}>
                                  {affiliation?.name}
                                </span>
                                , {affiliation?.state?.toLowerCase()}
                              </p>
                              <p className="mb-2"></p>
                            </React.Fragment>
                          );
                        });
                      })()}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion> */}
              </div>

              <div className="div30 ">
                <div className="journalslist custom-journalist-class">
                  <div className=" align-items-center">
                    <div className="ag_heading_center_wrap our-partner mt-0 info-custom">
                      <h2 className="tagh2">Information</h2>
                    </div>
                  </div>
                  <ul className="journalInfoList">
                    <li class="custom-li-journal tagli">
                      <Link
                        to={`/mega-journals/${id}`}
                        className={
                          activeType === "description" ? "active" : null
                        }
                        onClick={() => setActiveType("description")}
                      >
                        Description
                      </Link>
                    </li>
                    {id === "business-management" && (
                      <li class="custom-li-journal tagli">
                        <Link
                          to="/mega-journals/business-management/aims-and-scope"
                          className={
                            activeType === "aims-and-scope" ? "active" : null
                          }
                          onClick={() => {
                            setActiveType("aims-and-scope");
                          }}
                        >
                          Aims and Scope
                        </Link>
                      </li>
                    )}
                    <li class="custom-li-journal tagli">
                      <Link
                        to={`/mega-journals/${id}/all-articles`}
                        state={{
                          journalName: journalData?.journalName,
                          journalId: journalData?._id,
                        }}
                        className={
                          activeType === "all-articles" ? "active" : null
                        }
                        onClick={() => setActiveType("all-articles")}
                      >
                        Access Articles
                      </Link>
                    </li>

                    <li class="custom-li-journal tagli">
                      <Link
                        to="javascript:;"
                        className={
                          activeType === "editorial-board" ? "active" : null
                        }
                        onClick={() => setActiveType("editorial-board")}
                      >
                        Editorial Board
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="javascript:void(0);"
                        className={
                          activeType === "publishing-editors" ? "active" : null
                        }
                        onClick={(e) => {
                          setActiveType("publishing-editors"),
                            handleRedirect(
                              e,
                              `/mega-journals/${id}/publishing-editors`
                            );
                        }}
                      >
                        Publishing Editors
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="/author-submission-guidelines"
                        target="_blank"
                        className={
                          activeType === "author-guidelines" ? "active" : null
                        }
                      >
                        Author Guidelines
                      </Link>
                    </li>

                    <li class="custom-li-journal tagli">
                      <Link
                        className={
                          activeType === "content-type" ? "active" : null
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveType("content-type");
                          setShow(true);
                        }}
                      >
                        Content Type
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        className={activeType === "archives" ? "active" : null}
                        to={`/mega-journals/${id}`}
                        state={{
                          activeType: "archives",
                        }}
                      >
                        Archives
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        className={activeType === "recommend" ? "active" : null}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveType("recommend");
                          setShowRec(true);
                          setModalPageName(pageName);
                          setJournalModalName(journalName);
                        }}
                      >
                        Recommend
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="/how-we-publish"
                        target="_blank"
                        className={
                          activeType === "publishing-model" ? "active" : null
                        }
                      >
                        How We Publish
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        className={
                          activeType === "advertising" ? "active" : null
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveType("advertising");
                          setShowAdvertising(true);
                        }}
                      >
                        Advertise With Us
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="/journal/get-in-touch"
                        target="_blank"
                        className={
                          activeType === "get-in-touch" ? "active" : null
                        }
                      >
                        Get in Touch
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="journalslist martop-10 main-class-publish">
                  <div className="footer-align-bottom"></div>
                  <h2 className="font22 custom-24 tagh2 text-center">
                    Email Alerts
                  </h2>
                  {/* <p>Sign up to receive Email alerts</p> */}
                  <Link
                    to="/registration"
                    onClick={(e) => handleRedirect(e, "/registration")}
                    className="ag_btn_red signup-btn-journal taga"
                  >
                    SIGN UP
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NewsLetter />
        <SubmitArticleModal
          uploadArticle={uploadArticle}
          setUploadArticle={setUploadArticle}
        />
        <Modal
          show={showAdvertising}
          size="lg"
          backdrop="static"
          keyboard={false}
          centered
          aria-labelledby="contained-modal-title-vcenter markitPopupRecomendBox"
          className="markitPopupRecomendBox"
        >
          <Modal.Header className="justify-content-center closeButtonStyle">
            <Modal.Title className="modal-title pl-0">
              <h2 className="fontsizeshastra ml-2">Advertise With Us</h2>
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setShowAdvertising(false);
                setActiveType("description");
              }}
              aria-label="Close"
            />
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2">
            <div className="advertisingModal">
              <img src="/assets/images/advertising.png" alt="advertising" />
              <div className="advertisingContent">
                <span className="colorBlack">
                  For advertising inquiries, write to us at
                </span>{" "}
                <a href="mailto:contactus@vikramshilaedu.in">
                  contactus@vikramshilaedu.in
                </a>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={show}
          // onHide={handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter "
          centered
          className="markitPopupBox"
        >
          <Modal.Header
            className="justify-content-center closeButtonStyle"
            closeButton
            onClick={() => setShow(false)}
          >
            <Modal.Title className="modal-title pl-0">
              <h2 className="fontsizemod ml-2">
                Aakashganga currently accepts the following types of research
                articles for publishing
              </h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2">
            <div className="px-2 text-center">
              <p className="f-14">
                <ul className="contentModal">
                  <li className="section">
                    <strong>Original Research:</strong> These are original
                    research studies presenting new findings and insights in any
                    field of science or medicine.
                  </li>
                  <li className="efforts">
                    <strong>Review Articles:</strong> These provide
                    comprehensive and critical reviews of existing research,
                    summarizing and analysing the current state of knowledge on
                    a specific topic.
                  </li>
                  <li className="efforts">
                    <strong>Systematic Review:</strong> A comprehensive and
                    structured method of synthesizing and analyzing existing
                    research studies and evidence on a specific research
                    question or topic.
                  </li>
                  <li className="efforts">
                    <strong>Methodology Articles:</strong> These describe new
                    methods or techniques developed for research or data
                    analysis. Methodology articles focus on the technical
                    aspects of research and often include detailed protocols or
                    algorithms.
                  </li>
                  <li className="efforts">
                    <strong>Data Articles:</strong> These focus primarily on
                    data sets, describing and providing access to large data
                    collections or databases. Data articles may include data
                    descriptions, data analyses, and data visualization.
                  </li>
                  <li className="efforts">
                    <strong>Case Reports:</strong> These describe unique or
                    interesting medical or clinical cases that contribute to the
                    understanding of a particular disease, treatment, or
                    condition.
                  </li>
                  <li className="efforts">
                    <strong>Short Reports:</strong> These are concise research
                    papers presenting new and significant findings but with a
                    shorter format compared to full research articles.
                  </li>
                  <li className="efforts">
                    <strong>Perspectives or Opinions:</strong> These articles
                    express the authors’ perspectives, opinions, or commentaries
                    on a specific scientific, social, or ethical issue.
                  </li>
                  <li className="efforts">
                    <strong>Conceptual Articles:</strong> These articles propose
                    new concepts, frameworks, or theoretical models, often based
                    on existing research or literature.
                  </li>
                  <li className="efforts">
                    <strong>Commentaries:</strong> Commentaries offer critical
                    analysis or perspective on previously published research or
                    current issues within a field.
                  </li>
                  <li className="efforts">
                    <strong>Book Reviews:</strong> These articles evaluate and
                    critique recently published books relevant to the scope of
                    the journal.
                  </li>
                  <li className="efforts">
                    <strong>Conference Papers: </strong>Academics can publish
                    their conference papers on Aakashganga, showcasing original
                    research that unveils new discoveries and insights across
                    the seven Mega Journals on the platform.
                  </li>
                </ul>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-3 pb-3 contactModalFooter"></Modal.Footer>
        </Modal>

        <Modal
          show={showRec}
          onHide={() => setShowRec(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="markitPopupRecomendBox"
        >
          <Modal.Header
            className="justify-content-center closeButtonStyle"
            closeButton
            onClick={() => setActiveType("description")}
          >
            <Modal.Title className="modal-title">
              <h2 className="fontsizeshastra">Recommend {modalPageName}</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2 text-left recommendModalBox">
            <strong>Share it on:</strong>{" "}
            <ul className="ag_ftr_socials contentModal">
              <li>
                <FacebookShareButton
                  url={SHARE_URL}
                  title={title}
                  hashtags={"aakashganga"}
                >
                  <b>
                    <img
                      src="/assets/images/icon-facebook.svg"
                      alt="Facebook Icon"
                    />
                  </b>
                </FacebookShareButton>
              </li>
              <li>
                <TwitterShareButton
                  url={SHARE_URL}
                  title={title}
                  hashtag={"aakashganga"}
                >
                  <b>
                    <img
                      src="/assets/images/icon-twitter.svg"
                      alt="Twitter Icon"
                    />
                  </b>
                </TwitterShareButton>
              </li>
              <li>
                <LinkedinShareButton url={SHARE_URL} title={title}>
                  <b>
                    <img
                      src="/assets/images/icon-linkedIn.svg"
                      alt="LinkedIn Icon"
                    />
                  </b>
                </LinkedinShareButton>
              </li>
            </ul>
            <hr className="journalHr" />
            <strong>Copy Link:</strong>{" "}
            <div className="dis">
              <div class="ag_newsletter_input widrec">
                <input
                  type=""
                  value={SHARE_URL}
                  placeholder="Copy Link"
                ></input>
              </div>
              <a
                href="javascript:;"
                onClick={handleCodeCopy}
                className=" ag_btn_red ag_btn_redclr copy"
              >
                Copy
              </a>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-3 pb-3 contactModalFooter"></Modal.Footer>
        </Modal>
        <AakashgangaFooter />
      </div>
    </>
  );
};

export default MegaEditorialBoard;
